export const Title = () => {
  return <h1>You Game? </h1>;
};
